export default "__VITE_ASSET__e34cf167__"